module.exports = __webpack_public_path__ + "static/assets/7d95efe2667a62b78a31852ef1b931a0.png";